"use client"

import Link from "next/link"
import { Copy } from "lucide-react"
import { toast } from "sonner"
import { Logo } from "@/components/logo"

function CopyEmail({ email, className = "" }) {
  return (
    <button
      onClick={() => {
        navigator.clipboard.writeText(email)
        toast.success("Email address copied to clipboard")
      }}
      className={`inline-flex items-center gap-1 underline underline-offset-4 transition-colors hover:text-foreground ${className}`}
    >
      {email}
      <Copy className="h-3 w-3" />
    </button>
  )
}

const footerLink = "text-sm text-muted-foreground transition-colors hover:text-foreground"

export function SiteFooter() {
  return (
    <footer className="mt-auto border-t border-border/40 bg-muted/20 pt-12 pb-4">
      <div className="container mx-auto grid grid-cols-2 items-start gap-x-4 gap-y-6 px-6 md:grid-cols-4 md:justify-items-center md:px-24">
        <div className="col-span-2 mb-6 text-left md:col-auto">
          <Logo className="mb-4 h-8 w-auto" />
          <p className="max-w-xs pb-4 text-sm text-muted-foreground">
            Rank top 10% on your MMI with realistic AI stations, instant feedback, and expert coaching.
          </p>
          <CopyEmail email="hello@mmipractice.org" className="text-sm text-muted-foreground" />
        </div>

        <div className="text-left">
          <h3 className="mb-2 font-semibold text-foreground">Practice</h3>
          <ul>
            <li><Link href="/mmi-practice-questions" className={footerLink}>MMI practice questions</Link></li>
            <li><Link href="/app" className={footerLink}>Practice stations</Link></li>
            <li><Link href="/#pricing" className={footerLink}>Pricing</Link></li>
          </ul>
        </div>

        <div className="text-left">
          <h3 className="mb-2 font-semibold text-foreground">Resources</h3>
          <ul>
            <li><Link href="/mmi-prep" className={footerLink}>MMI prep guide</Link></li>
            <li><Link href="/#faq" className={footerLink}>FAQ</Link></li>
            <li><Link href="https://www.casperpractice.org" className={footerLink}>Casper Test Practice</Link></li>
          </ul>
        </div>

        <div className="text-left">
          <h3 className="mb-2 font-semibold text-foreground">Legal</h3>
          <ul>
            <li><Link href="/terms" className={footerLink}>Terms of use</Link></li>
            <li><Link href="/privacy" className={footerLink}>Privacy policy</Link></li>
            <li><Link href="/affiliates" className={footerLink}>Affiliate program</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-6 border-t border-border/40 pt-4">
        <p className="text-center text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} MMI Practice. All rights reserved.
        </p>
        <p className="container mx-auto mt-2 px-6 text-center text-xs text-muted-foreground md:px-24">
          MMIPractice is an independent platform and is not affiliated with any university, medical school, or
          admissions organization. Our practice materials are based on publicly available information about the
          MMI format. As with any AI platform, AI-generated results may vary. We continuously refine our platform
          based on user input - if you spot any errors or inconsistencies, please let us know!
        </p>
      </div>
    </footer>
  )
}
